__turbopack_context__.v({
  "appMain": "TariffCalculator-module-scss-module__0givjW__appMain",
  "appear": "TariffCalculator-module-scss-module__0givjW__appear",
  "benefit": "TariffCalculator-module-scss-module__0givjW__benefit",
  "breakdownTable": "TariffCalculator-module-scss-module__0givjW__breakdownTable",
  "breakdownTariff": "TariffCalculator-module-scss-module__0givjW__breakdownTariff",
  "breakdownTotal": "TariffCalculator-module-scss-module__0givjW__breakdownTotal",
  "breakdownWrap": "TariffCalculator-module-scss-module__0givjW__breakdownWrap",
  "calculatorShell": "TariffCalculator-module-scss-module__0givjW__calculatorShell",
  "chartAntdModal": "TariffCalculator-module-scss-module__0givjW__chartAntdModal",
  "chartBox": "TariffCalculator-module-scss-module__0givjW__chartBox",
  "chartDialogInner": "TariffCalculator-module-scss-module__0givjW__chartDialogInner",
  "chartLegend": "TariffCalculator-module-scss-module__0givjW__chartLegend",
  "choice": "TariffCalculator-module-scss-module__0givjW__choice",
  "choiceGrid": "TariffCalculator-module-scss-module__0givjW__choiceGrid",
  "choiceText": "TariffCalculator-module-scss-module__0givjW__choiceText",
  "conservative": "TariffCalculator-module-scss-module__0givjW__conservative",
  "eyebrow": "TariffCalculator-module-scss-module__0givjW__eyebrow",
  "fieldGrid": "TariffCalculator-module-scss-module__0givjW__fieldGrid",
  "fieldGridTight": "TariffCalculator-module-scss-module__0givjW__fieldGridTight",
  "fieldNumber": "TariffCalculator-module-scss-module__0givjW__fieldNumber",
  "fieldNumberInput": "TariffCalculator-module-scss-module__0givjW__fieldNumberInput",
  "formBody": "TariffCalculator-module-scss-module__0givjW__formBody",
  "formError": "TariffCalculator-module-scss-module__0givjW__formError",
  "hero": "TariffCalculator-module-scss-module__0givjW__hero",
  "heroFact": "TariffCalculator-module-scss-module__0givjW__heroFact",
  "heroSide": "TariffCalculator-module-scss-module__0givjW__heroSide",
  "heroWrapper": "TariffCalculator-module-scss-module__0givjW__heroWrapper",
  "hint": "TariffCalculator-module-scss-module__0givjW__hint",
  "legendSwatch": "TariffCalculator-module-scss-module__0givjW__legendSwatch",
  "linkButton": "TariffCalculator-module-scss-module__0givjW__linkButton",
  "methodCollapse": "TariffCalculator-module-scss-module__0givjW__methodCollapse",
  "methodList": "TariffCalculator-module-scss-module__0givjW__methodList",
  "metric": "TariffCalculator-module-scss-module__0givjW__metric",
  "modalCta": "TariffCalculator-module-scss-module__0givjW__modalCta",
  "negative": "TariffCalculator-module-scss-module__0givjW__negative",
  "nextButton": "TariffCalculator-module-scss-module__0givjW__nextButton",
  "platinum": "TariffCalculator-module-scss-module__0givjW__platinum",
  "positive": "TariffCalculator-module-scss-module__0givjW__positive",
  "privacy": "TariffCalculator-module-scss-module__0givjW__privacy",
  "progressBar": "TariffCalculator-module-scss-module__0givjW__progressBar",
  "progressHead": "TariffCalculator-module-scss-module__0givjW__progressHead",
  "progressTrack": "TariffCalculator-module-scss-module__0givjW__progressTrack",
  "progressWrap": "TariffCalculator-module-scss-module__0givjW__progressWrap",
  "resultActions": "TariffCalculator-module-scss-module__0givjW__resultActions",
  "resultActionsRight": "TariffCalculator-module-scss-module__0givjW__resultActionsRight",
  "resultBody": "TariffCalculator-module-scss-module__0givjW__resultBody",
  "resultTop": "TariffCalculator-module-scss-module__0givjW__resultTop",
  "results": "TariffCalculator-module-scss-module__0givjW__results",
  "scenario": "TariffCalculator-module-scss-module__0givjW__scenario",
  "scenarioGrid": "TariffCalculator-module-scss-module__0givjW__scenarioGrid",
  "scenarioSwitch": "TariffCalculator-module-scss-module__0givjW__scenarioSwitch",
  "sectionTitle": "TariffCalculator-module-scss-module__0givjW__sectionTitle",
  "siteHeader": "TariffCalculator-module-scss-module__0givjW__siteHeader",
  "startFree": "TariffCalculator-module-scss-module__0givjW__startFree",
  "stepActions": "TariffCalculator-module-scss-module__0givjW__stepActions",
  "stepLead": "TariffCalculator-module-scss-module__0givjW__stepLead",
  "stepPanel": "TariffCalculator-module-scss-module__0givjW__stepPanel",
  "stepTitle": "TariffCalculator-module-scss-module__0givjW__stepTitle",
  "summaryCard": "TariffCalculator-module-scss-module__0givjW__summaryCard",
  "summaryGrid": "TariffCalculator-module-scss-module__0givjW__summaryGrid",
  "tableScroll": "TariffCalculator-module-scss-module__0givjW__tableScroll",
  "tariffCard": "TariffCalculator-module-scss-module__0givjW__tariffCard",
  "tariffCompareLink": "TariffCalculator-module-scss-module__0givjW__tariffCompareLink",
  "tariffCta": "TariffCalculator-module-scss-module__0givjW__tariffCta",
  "tariffCtaRow": "TariffCalculator-module-scss-module__0givjW__tariffCtaRow",
  "tariffEyebrow": "TariffCalculator-module-scss-module__0givjW__tariffEyebrow",
  "tariffInfo": "TariffCalculator-module-scss-module__0givjW__tariffInfo",
  "tariffPrice": "TariffCalculator-module-scss-module__0givjW__tariffPrice",
  "tariffTop": "TariffCalculator-module-scss-module__0givjW__tariffTop",
  "timeRow": "TariffCalculator-module-scss-module__0givjW__timeRow",
  "timeTable": "TariffCalculator-module-scss-module__0givjW__timeTable",
  "zeroCommission": "TariffCalculator-module-scss-module__0givjW__zeroCommission",
});
